/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RedirectUrlDto
 */
export interface RedirectUrlDto {
    /**
     * 
     * @type {string}
     * @memberof RedirectUrlDto
     */
    url: string;
}

export function RedirectUrlDtoFromJSON(json: any): RedirectUrlDto {
    return RedirectUrlDtoFromJSONTyped(json, false);
}

export function RedirectUrlDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RedirectUrlDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': json['url'],
    };
}

export function RedirectUrlDtoToJSON(value?: RedirectUrlDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
    };
}

